import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import {
  MdDescription,
  MdFullscreen,
  MdFullscreenExit,
  MdVolumeOff,
  MdVolumeUp,
} from "react-icons/md";
import officialLogo from "../../assets/logo/the-first-noncarbon-artist.png";
import "./ArtworkControlDeck.css";

const ArtworkControlDeck = ({
  enabled = true,
  showDescriptionControl = true,
  descriptionOpen = false,
  onDescriptionToggle,
  descriptionTitle = "Artwork note",
  descriptionEyebrow = "The First NonCarbon Artist",
  description = "",
  showAudioControl = true,
  audioEnabled = false,
  onAudioToggle,
  isFullscreen = false,
  onFullscreenToggle,
}) => {
  if (!enabled) {
    return null;
  }

  return (
    <div className="artwork-control-deck">
      <div className="artwork-control-deck__buttons">
        {showDescriptionControl && (
          <button
            type="button"
            className={`artwork-control-deck__button${
              descriptionOpen ? " is-active" : ""
            }`}
            onClick={onDescriptionToggle}
            aria-pressed={descriptionOpen}
            aria-label={
              descriptionOpen
                ? "Hide artwork description"
                : "Show artwork description"
            }
          >
            <MdDescription aria-hidden="true" />
          </button>
        )}

        {showAudioControl && (
          <button
            type="button"
            className={`artwork-control-deck__button${
              audioEnabled ? " is-active" : ""
            }`}
            onClick={onAudioToggle}
            aria-pressed={audioEnabled}
            aria-label={audioEnabled ? "Turn artwork audio off" : "Turn artwork audio on"}
          >
            {audioEnabled ? (
              <MdVolumeUp aria-hidden="true" />
            ) : (
              <MdVolumeOff aria-hidden="true" />
            )}
          </button>
        )}

        <button
          type="button"
          className="artwork-control-deck__button"
          onClick={onFullscreenToggle}
          aria-pressed={isFullscreen}
          aria-label={
            isFullscreen
              ? "Reduce current group from fullscreen"
              : "Expand current group to fullscreen"
          }
        >
          {isFullscreen ? (
            <MdFullscreenExit aria-hidden="true" />
          ) : (
            <MdFullscreen aria-hidden="true" />
          )}
        </button>
      </div>

      <AnimatePresence initial={false}>
        {showDescriptionControl && descriptionOpen && (
          <motion.aside
            key="artwork-description-card"
            className="artwork-description-card"
            initial={{
              opacity: 0,
              x: -10,
              scale: 0.96,
              filter: "blur(8px)",
            }}
            animate={{
              opacity: 1,
              x: 0,
              scale: 1,
              filter: "blur(0px)",
            }}
            exit={{
              opacity: 0,
              x: -8,
              scale: 0.98,
              filter: "blur(6px)",
            }}
            transition={{
              duration: 0.42,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            <div className="artwork-description-card__ink" />
            <div className="artwork-description-card__highlight" />
            <div className="artwork-description-card__header">
              <div className="artwork-description-card__logo-shell">
                <img
                  src={officialLogo}
                  alt="The First NonCarbon Artist"
                  className="artwork-description-card__logo"
                />
              </div>
              <div className="artwork-description-card__meta">
                <span className="artwork-description-card__eyebrow">
                  {descriptionEyebrow}
                </span>
                <h3 className="artwork-description-card__title">
                  {descriptionTitle}
                </h3>
              </div>
            </div>
            <p className="artwork-description-card__body">{description}</p>
          </motion.aside>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ArtworkControlDeck;
